/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "fgrApi",
            "endpoint": "https://j8s5anm8ra.execute-api.eu-west-2.amazonaws.com/ecoprod",
            "region": "eu-west-2"
        },
        {
            "name": "fgrWebhooks",
            "endpoint": "https://6oj9iqanvf.execute-api.eu-west-2.amazonaws.com/ecoprod",
            "region": "eu-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-2:d2f0112a-a9ec-4364-817b-2ed980754a17",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_1aG0Ipyhq",
    "aws_user_pools_web_client_id": "1emsuo2gqurjav2mml6vd6idgn",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
